<ng-content class="app-page-container"></ng-content>
